/**
 * BAMBOOVE · "THÔNG BÁO KHI CÓ HÀNG LẠI" (Notify me when back in stock)
 * 08/10/2026 · phiên 47
 * ---------------------------------------------------------------------------
 * VÌ SAO: khách vào đúng sản phẩm/cỡ mình muốn mà HẾT HÀNG thì hiện tại họ đi mất,
 * không để lại gì. Đo được (benchmark 3.908 cửa hàng, 2026):
 *   · 10–20% khách ở trang hết hàng CHỊU để lại email
 *   · email báo có hàng lại: mở 58–65% · bấm 21–35% · mua 30,5% số người bấm
 *   · cửa hàng trung bình chốt 11,3% số người đã đăng ký (nhóm top >21%)
 * Nên đây là "bảo hiểm doanh thu": tốn 0 đồng, chỉ chạy khi thật sự hết hàng.
 *
 * CÁCH LÀM (không cần app):
 *   Dùng FORM KHÁCH HÀNG THẬT của Shopify (`{% form 'customer' %}`) + gắn TAG:
 *     restock · restock-<handle sản phẩm> · restock-variant-<id biến thể>
 *   ⇒ khách vào thẳng danh sách khách của shop, lọc theo tag là ra đúng người cần báo.
 *   Ô "note" của khách ghi rõ sản phẩm/cỡ + ngày ⇒ chủ máy nhìn Admin là biết báo gì.
 *
 * KHÔNG tự viết lại máy biến thể: đọc đúng 2 khối dữ liệu mà Liquid đã đổ ra
 *   `[data-bb-variants]` (variants JSON) và `[data-bb-prices]` (giá + còn hàng),
 *   lắng nghe sự kiện `bb:pdp-cap-nhat` do `bamboove-pdp.js` bắn ra mỗi lần đổi màu/cỡ.
 */
(function () {
  var khoi = document.querySelector('[data-bb-conhang]');
  if (!khoi) return;

  var form = khoi.querySelector('form');
  var oTags = khoi.querySelector('[data-bb-conhang-tags]');
  var oGhi = khoi.querySelector('[data-bb-conhang-ghi]');
  var oTen = khoi.querySelector('[data-bb-conhang-ten]');
  var oVariant = document.querySelector('[data-bb-variant]');
  var sp = khoi.getAttribute('data-bb-conhang-sp') || '';
  var variants = [];
  var prices = {};
  try {
    variants = JSON.parse(document.querySelector('[data-bb-variants]').textContent) || [];
  } catch (e) { /* khong co du lieu */ }
  try {
    prices = JSON.parse(document.querySelector('[data-bb-prices]').textContent) || {};
  } catch (e) { /* khong co du lieu */ }

  /* Để XEM THỬ thiết kế khi mọi cỡ còn hàng: thêm ?bb_thu_conhang=1 vào URL
     (hoặc bật tích "LUÔN hiện" trong Trình soạn theme). */
  var luonHien = khoi.getAttribute('data-bb-conhang-luon') === '1' ||
    /[?&]bb_thu_conhang=1/.test(window.location.search);

  function tim(id) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function capNhat() {
    /* Vừa gửi email xong: LUÔN hiện (nếu không, khách đổi sang cỡ còn hàng là mất câu xác nhận).
       Dấu này do Liquid chèn BÊN TRONG khối form (script type=hidden) — xem ghi chú trong section. */
    if (khoi.querySelector('[data-bb-conhang-xong]')) {
      khoi.hidden = false;
      return;
    }
    var id = oVariant ? oVariant.value : '';
    var v = tim(id);
    var conHang = prices[id] ? !!prices[id].a : (v ? !!v.available : true);
    var hien = luonHien || (!!id && !conHang);
    if (khoi.hidden === hien) khoi.hidden = !hien;
    if (!hien) return;

    if (v) {
      if (oTen) oTen.textContent = v.title ? ' — ' + v.title : '';
      if (oTags) {
        oTags.value = 'restock,restock-' + sp + ',restock-variant-' + v.id;
      }
      if (oGhi) {
        var ngay = new Date().toISOString().slice(0, 10);
        oGhi.value = 'Restock request: ' + sp + ' · ' + (v.title || '') +
          ' · variant ' + v.id + ' · ' + ngay;
      }
    }
  }

  /* (1) Sự kiện chính: bamboove-pdp.js bắn ra sau mỗi lần đổi màu/cỡ */
  document.addEventListener('bb:pdp-cap-nhat', capNhat);
  /* (2) Lưới an toàn: đổi cỡ/màu luôn là do BẤM ⇒ bắt ở tầng document */
  document.addEventListener('click', function () { setTimeout(capNhat, 0); }, true);
  document.addEventListener('change', function () { setTimeout(capNhat, 0); }, true);
  /* (3) Vào trang bằng ?variant=<id> hoặc JS của theme chạy chậm hơn */
  capNhat();
  var dem = 0;
  var nhac = setInterval(function () {
    capNhat();
    if (++dem > 20) clearInterval(nhac);
  }, 500);

  if (form) form.addEventListener('submit', capNhat);
})();
